import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ILeadView } from '../viewModels/leads/interfaces';
import * as Api from '@ViewModels';

export interface PracticeLeadRequest {
	previousCompanyIds?: string[];
	ruleId?: string;
}

export const usePracticeLead = () => {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async ({ previousCompanyIds = [], ruleId }: PracticeLeadRequest = {}): Promise<ILeadView> => {
			const queryParams: Record<string, any> = {
				mode: 'PracticeCall',
			};

			if (ruleId) {
				queryParams.ruleId = ruleId;
			}

			// Convert array to comma-separated string for API
			if (previousCompanyIds.length > 0) {
				queryParams.previousCompanyIds = previousCompanyIds.join(',');
			}

			const response = await userSession.webServiceHelper.callWebServiceAsync<ILeadView>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'lead',
					queryParams,
				}),
				'GET'
			);

			if (!response.success) {
				throw new Error(response.systemMessage || 'Failed to fetch practice lead');
			}

			if (!response.value) {
				throw new Error('No practice lead available');
			}

			return response.value;
		},
		onError: (error: Error) => {
			console.error('Failed to fetch practice lead:', error);
		},
	});
};
